module.exports = JBrowseExports["react-dom/client"];